'use client'

import { FC, useEffect } from 'react'

const scriptId = 'spec-rules'
const SpeculationRules: FC = () => {
  // No local "loaded" state: the DOM (document.getElementById) is already the guard against
  // double-insertion, so there's nothing left to synchronize into React state. [S20-865]
  useEffect(() => {
    if (document.getElementById(scriptId)) return
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      const specScript = document.createElement('script')
      specScript.type = 'speculationrules'
      specScript.id = scriptId
      const specRules = {
        prerender: [
          {
            source: 'document',
            where: {
              or: [
                { href_matches: '/' },
                { href_matches: '/jobs*' },
                { href_matches: '/search*' },
                { href_matches: '/(blogs|legal|login|privacy|welcome-video)/' },
              ],
            },
            eagerness: 'moderate',
          },
        ],
      }
      specScript.textContent = JSON.stringify(specRules)
      document.body.append(specScript)
    }
  }, [])
  return <></>
}

export default SpeculationRules
